<template>
  <div v-if="isLoading" class="flex items-center justify-center">
    <Loader color="#64748B" width="50px" height="50px" />
  </div>
  <template v-else>
    <button v-if="(lastPath === '/block') || (lastPath === '/search-result')"
      class="bg-white uppercase border-2 border-red text-blue-dark px-7 py-0.5 md:m-0 mb-10" style="border-radius: 3px"
      @click="goBack">
      Back
    </button>
    <div class="">
      <div v-if="assetHash" class="flex items-center gap-[10px]">
        <HeadingComponent :text="assetHash"
          class="text-left text-[33px] font-jost-regular text-blue-light break-all leading-[47px]" />
        <CopyIcon :isActive="checkIfIsEqual(assetHash)" @click="copy(assetHash)"
          title="Copy hash"
          class="min-w-[16px] h-[19px] inline-block cursor-pointer align-text-top" />
      </div>
      <div v-if="assetDetails && Object.keys(assetDetails).length > 0">
        <div class="mt-[66px]">
          <Paragraph class="font-inter-regular text-[#2A4067] text-[25px] leading-[30px] !mb-[17px]" text="Overview" />
          <div class="max-w-max flex gap-[93px] bg-white rounded-[12px] px-[22px] py-[5px] mt-[20px]">
            <div class="flex-grow max-w-[664px]">
              <div class="flex gap-[105px] border-b border-[#2699FB] py-[23px]">
                <Paragraph class="font-jost-regular text-[#2A4067] text-[18px] leading-[21px] min-w-[180px]"
                  text="Symbol" />
                <Paragraph class="font-jost-regular text-[#5B6BD5] text-[18px] leading-[21px]"
                  :text="`${assetDetails.symbol ? assetDetails.symbol : ''}`" />
              </div>
              <div class="flex gap-[105px] border-b border-[#2699FB] py-[23px]">
                <Paragraph class="font-jost-regular text-[#2A4067] text-[18px] leading-[21px] min-w-[180px]"
                  text="Total Supply" />
                <Paragraph class="font-jost-regular text-[#5B6BD5] text-[18px] leading-[21px]"
                  :text="`${assetDetails.totalSupply ? assetDetails.totalSupply : ''}`" />
              </div>
              <div class="flex gap-[105px] border-b border-[#2699FB] py-[23px]">
                <Paragraph class="font-jost-regular text-[#2A4067] text-[18px] leading-[21px] min-w-[180px]"
                  text="Decimal Places" />
                <Paragraph class="font-jost-regular text-[#5B6BD5] text-[18px] leading-[21px]"
                  :text="`${assetDetails.decimalPlaces ? assetDetails.decimalPlaces : ''}`" />
              </div>
              <div class="flex gap-[105px] py-[23px]">
                <Paragraph class="font-jost-regular text-[#2A4067] text-[18px] leading-[21px] min-w-[180px]"
                  text="Issuing Account / Proxy" />
                <Paragraph class="font-jost-regular text-[#5B6BD5] text-[18px] leading-[21px]"
                  :text="`${assetDetails.creator ? assetDetails.creator : ''}`" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div>
          <Paragraph class="text-left text-[25px] text-blue-dark font-jost-regular leading-[36px]"
            text="There is no data for this asset" />
        </div>
      </div>
    </div>
  </template>
</template>

<script>
import "vue-json-pretty/lib/styles.css";
import Paragraph from "@/components/web/ParagraphComponent";
import { mapGetters } from 'vuex';
import api from '@/helpers/api';
import string from '@/helpers/string';
import HeadingComponent from '@/components/web/HeadingComponent';
import CopyIcon from '@/components/svg/CopyIcon';
import Loader from '@/components/common/Loader.vue';

export default {
  name: "AssetComponent",
  components: {
    CopyIcon,
    Paragraph,
    HeadingComponent,
    Loader,
  },
  data: () => {
    return {
      copied: '',
      isLoading: false,
      assetDetails: {
        items: [],
        symbol: 'USDC',
        totalSupply: 'jbkhbkhbhkbkh',
        decimalPlaces: '6',
        creator: 'gsdhgsgsdhrd',
      },
      lastPath: null,
    }
  },
  computed: {
    assetHash() {
      return this.$route.params.assetHash;
    },
  },
  created() {
    this.lastPath = this.$router.options.history.state.back;
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    getassetDetails() {
      this.isLoading = true;

      return api.getAssetDetails(this.assetHash)
        .then((res) => {
          const data = res.data;
          this.assetDetails = {...data};
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
        })
    },
    copy(hash, uId = 0) {
      string.copyToClipboard(hash);
      this.setCopied(hash + uId);
    },
    checkIfIsEqual(str, uId = 0) {
      return string.isTextEqualTo(str, this.copied, uId);
    },
    setCopied(hash) {
      this.copied = hash;
    },
  }
}
</script>
<style scoped>
.icon {
  display: inline-block;
  vertical-align: middle;
}
.icon--plus > path {
  fill: #3D94C3;
  stroke: #3D94C3;
  stroke-width: 0.01;
  stroke-linejoin: round;
}
header, .row {
  display: flex;  /* aligns all child elements (flex items) in a row */
}

.col {
  flex: 1;        /* distributes space on the line equally among items */
  width: calc(100% / 3);
}
.popover__content {
  right: unset;
  left: 10px;
  bottom: 0;
}
.result-row {
  min-height: 54px;
}
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #666666;
}
</style>
